import {Directive,inject} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
	selector:'[appInputEmptyToNull]',
	host:{
		'(input)':'onEvent($event)',
		'(blur)':'onEvent($event)'
	}
})
export class InputEmptyToNullDirective{
	private readonly ngControl=inject(NgControl);
	
	onEvent(event:Event):void{
		const target=event.target as HTMLInputElement;
		this.ngControl.control!.setValue(target.value==='' ? null : target.value);
	}
}
